module.exports = __webpack_public_path__ + "static/media/02.1.Stage View.ba1877d9.JPG";